import TargetZoneDetails from "./TargetZoneDetails";
export default TargetZoneDetails;
